import { initStorageInstance } from './index'
import { INVOICE_USER_SELECT_KEY } from './constant'

export const InvoiceUserSelectStorage = initStorageInstance(INVOICE_USER_SELECT_KEY, {
  type: 'sessionStorage',
})
